import $ from 'jquery';
import {
  magicFrameChangePersonPhoto,
  magicFrameChangeBackgroundPhoto,
  toggleMagicFrameEditMode,
  magicFrameChangeFramePhoto,
} from '~core/magicFrame';
import { getActiveMagicFrameActive } from '~core/magicFrame';
import { triggerStateChangedRequest } from '~core';

export const initMagicFrameEventListeners = () => {
  $('body').on(
    'click',
    '#btn-magicframe-change-person-photo',
    magicFrameChangePersonPhoto
  );
  $('body').on(
    'click',
    '#btn-magicframe-change-frame-photo',
    magicFrameChangeFramePhoto
  );
  $('body').on(
    'click',
    '#btn-magicframe-change-bg-photo',
    magicFrameChangeBackgroundPhoto
  );
  $('body').on('click', '#btn-magicframe-modify-person-photo', () => {
    toggleMagicFrameEditMode();
  });
  $('body').on('click', '#btn-magicframe-remove-frame', () => {
    const magicFrame = getActiveMagicFrameActive();
    if (!magicFrame) {
      return;
    }
    magicFrame.removeFrame();
    window.canvas.renderAll();
    triggerStateChangedRequest();
  });
  $('body').on('click', '#btn-magicframe-remove-background', () => {
    const magicFrame = getActiveMagicFrameActive();
    if (!magicFrame) {
      return;
    }
    magicFrame.removeBackground();
    window.canvas.renderAll();
    triggerStateChangedRequest();
  });
};
